import { useCallback } from 'react';
import { DmProject, DmProjectFile, updateDmProject, updateDmProjectFile } from '../api-services/dm-projects.client';
import { useToast } from '../context/toast-context';


interface UseUpdateProjectReturn {
    updateProjectHook: (projectId: string, updates: Partial<DmProject>) => Promise<void>;
    updateDmProjectFileHook: (projectId: string, s3Key: string, updates: Partial<DmProjectFile>) => Promise<void>;
}

export function useUpdateProject(): UseUpdateProjectReturn {
    const { showToast } = useToast();

    const updateProjectHook = useCallback(async (projectId: string, updates: Partial<DmProject>) => {
        try {
            const response = await updateDmProject(projectId, updates);
            if (response?.id) {
                showToast({
                    message: 'Project updated successfully',
                    severity: 'success',
                });
            } else {
                showToast({
                    message: 'Error updating project',
                    severity: 'error',
                });
            }
        } catch (error) {
            showToast({
                message: 'Error updating project',
                severity: 'error',
            });
            console.error(error);
        }
    }, []);

    const updateDmProjectFileHook = useCallback(async (projectId: string, s3Key: string, updates: Partial<DmProjectFile>) => {
        try {
            const response = await updateDmProjectFile(projectId, s3Key, updates);
            if (response?.id) {
                showToast({
                    message: 'File updated successfully',
                    severity: 'success',
                });
            } else {
                showToast({
                    message: 'Error updating file',
                    severity: 'error',
                });
            }
        } catch (error) {
            showToast({
                message: 'Error updating file',
                severity: 'error',
            });
            console.error(error);
        }
    }, []);

    return { updateProjectHook, updateDmProjectFileHook };
}